import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";

import MissingPatchesData from '../../../data/ops-view/SecurityStackEndpointSecurity/MissingPatches.json';

const MissingPatches = (props) => {

  const [onLoading, setOnLoading] = useState(false)

  const data = props.data.charts;

  const [parentWidth, setParentWidth] = useState(0);


  useEffect(() => {
    const updateParentWidth = () => {
      const parentDiv = document.getElementById('parentDiv');
      if (parentDiv) {
        const width = parentDiv.offsetWidth;
        setParentWidth(width * 0.95); // Assigning 90% width
      }
    };

    updateParentWidth();

    window.addEventListener('resize', updateParentWidth);

    return () => {
      window.removeEventListener('resize', updateParentWidth);
    };
  }, []);


  return (
    <div style={{
      width: '67%', marginLeft: 0, display: 'flex', flexDirection: 'column', 
      height: 460,
      marginTop: '2%', 
      background: 'linear-gradient(135deg, #161c2a, #1a2130)', padding: 20, borderRadius: 15
    }}>


    

      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 10 }}>


        <div style={{ width: '100%' }}>

          <h6 style={{ color: '#fff', textAlign: 'left' }}>Missing Patches</h6>
          <hr />


          <div style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
            alignItems: 'center',
          }}>

          
<table style={{ width: '100%' }}>
      <thead>
        <tr>
          <th style={{ padding: 20,color:'#fff' }}>Asset</th>
          <th style={{ padding: 20,color:'#fff' }}>Patch</th>
          <th style={{ padding: 20,color:'#fff' }}>Hosts</th>
        </tr>
      </thead>

      <tbody>
        {data.missingPatches.map((item, index) => (
          <tr key={index}>
            <td style={{ padding: 20 }}>{item.asset}</td>
            <td style={{ padding: 20 }}>{item.patch}</td>
            <td style={{ padding: 20 }}>{item.hosts}</td>
            
          </tr>
        ))}
      </tbody>
    </table>




          </div>
        </div>
      </div>


    </div>
  );
};

export default MissingPatches;